import { Selector } from '@ngrx/store/src/models';

import { getMetaAdapter, getMetaSelectors } from '../meta-adapter';
import { createSimpleSelector, namedProjector } from '../selector-utils';
import { getSingleEntityActions } from './actions';
import { getSingleEntityDataAdapter } from './data';
import { SingleEntityAdapter, SingleEntityState } from './types';

const singleEntityInitialState: SingleEntityState<any> = Object.freeze({
  data: null,
  loaded: false,
  pending: false,
  failed: false,
  error: null,
} as const);

export const createSingleEntityAdapter = <T extends object>(
  baseSelector: Selector<any, SingleEntityState<T>>,
  namespace: string,
) => {
  const adapter: SingleEntityAdapter<T> = {
    ...getMetaAdapter<SingleEntityState<T>>(),
    ...getSingleEntityDataAdapter(singleEntityInitialState),
  };

  const defaultActions = getSingleEntityActions<T>(adapter);

  const selectors = {
    ...getMetaSelectors(baseSelector, namespace),
    data: createSimpleSelector(
      baseSelector,
      namedProjector(`${namespace}Data`, state => state.data),
    ),
    state: createSimpleSelector(
      baseSelector,
      namedProjector(`${namespace}State`, state => state),
    ),
  };

  return {
    adapter,
    selectors,
    defaultActions,
    initialState: <SingleEntityState<T>>singleEntityInitialState,
  };
};
